import { SliderConfig } from "../types/sliderConfig";

export const draftSliderConfigs: SliderConfig<"shame" | "risk" | "effects">[] =
  [
    { key: "shame", label: "Effort level", min: 0, max: 5 },
    { key: "risk", label: "Skill level", min: 0, max: 5 },
    { key: "effects", label: "Physicality level", min: 0, max: 5 },
  ];
